exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".expand-enter-active[data-v-26a5e93e],.expand-leave-active[data-v-26a5e93e]{transition:height .3s ease-in-out,opacity .3s ease-in-out;transition-property:opacity,height;overflow:hidden}.expand-enter[data-v-26a5e93e],.expand-leave-to[data-v-26a5e93e]{height:0;opacity:0}", ""]);

// exports
